/**
 * Wishlist Hero header: icon color from app dashboard (link/SVG `color` before path fill).
 */
(function () {
  function isUsableColor(c) {
    if (!c || typeof c !== 'string') return false;
    var t = c.trim().toLowerCase();
    return t !== '' && t !== 'none' && t !== 'transparent' && t !== 'rgba(0, 0, 0, 0)';
  }

  function pickWlhDashboardIconColor(host, svg, path) {
    var c;
    if (host.style && host.style.color) {
      c = host.style.color.trim();
      if (isUsableColor(c)) return c;
    }
    if (svg) {
      c = svg.getAttribute('color');
      if (isUsableColor(c)) return c.trim();
      if (svg.style && svg.style.color) {
        c = svg.style.color.trim();
        if (isUsableColor(c)) return c;
      }
    }
    c = getComputedStyle(host).color;
    if (isUsableColor(c)) return c;
    if (svg) {
      c = getComputedStyle(svg).color;
      if (isUsableColor(c)) return c;
      c = getComputedStyle(svg).fill;
      if (isUsableColor(c) && c !== 'none') return c;
    }
    if (path) {
      c = getComputedStyle(path).fill;
      if (isUsableColor(c) && c !== 'none') return c;
    }
    return getComputedStyle(host).color || '';
  }

  /** Hide bubble when WLH keeps `wishlist-hero-items-count-exists` but count text is empty / 0 */
  function wlhHeaderBadgeVisibility() {
    var sel =
      '.wishlisthero-header-block .wishlist-hero-items-count.wishlist-hero-items-count-exists, a.wishlist-hero-header-icon .wishlist-hero-items-count.wishlist-hero-items-count-exists';
    document.querySelectorAll(sel).forEach(function (el) {
      var text = (el.textContent || '').replace(/\s/g, '');
      var n = parseInt(text, 10);
      var show = text !== '' && !isNaN(n) && n > 0;
      if (show) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function wlhHeaderIconColor() {
    document.querySelectorAll('a.wishlist-hero-header-icon').forEach(function (a) {
      var svg = a.querySelector('.wlh-svg-Icon') || a.querySelector('svg');
      if (!svg) return;
      var path = svg.querySelector('path');
      var c = pickWlhDashboardIconColor(a, svg, path);
      if (!isUsableColor(c)) return;
      a.style.setProperty('--wlh-header-icon-color', c);
      a.style.color = c;
    });
  }

  var t;
  function debouncedSync() {
    clearTimeout(t);
    t = setTimeout(function () {
      wlhHeaderIconColor();
      wlhHeaderBadgeVisibility();
    }, 30);
  }

  function observeBlocks() {
    document.querySelectorAll('.wishlisthero-header-block').forEach(function (block) {
      if (block.dataset.wlhNostebarnColorObs) return;
      block.dataset.wlhNostebarnColorObs = '1';
      new MutationObserver(debouncedSync).observe(block, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
        attributeFilter: ['style', 'class', 'color'],
      });
    });
  }

  function kick() {
    wlhHeaderIconColor();
    wlhHeaderBadgeVisibility();
    observeBlocks();
    requestAnimationFrame(wlhHeaderIconColor);
    requestAnimationFrame(function () {
      requestAnimationFrame(wlhHeaderIconColor);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kick);
  else kick();
  setTimeout(function () {
    wlhHeaderIconColor();
    wlhHeaderBadgeVisibility();
  }, 400);
  setTimeout(function () {
    wlhHeaderIconColor();
    wlhHeaderBadgeVisibility();
  }, 1200);
  setTimeout(function () {
    wlhHeaderIconColor();
    wlhHeaderBadgeVisibility();
  }, 2500);
  document.addEventListener('shopify:section:load', function () {
    setTimeout(kick, 50);
  });
})();
